import React from 'react'
import * as RoomPlan from 'modules/room_plan/components/Reference'
import * as Property from 'modules/property/components/Reference'
import * as PropertyType from 'modules/property_type/components/Reference'
import * as styles from './style.module.scss'

export const Content = ({ className, separator = '/' }) => {
  return (
    <div className={className ?? styles.Container}>
      <PropertyType.Properties.Label />
      {separator}
      <Property.Properties.Name />
      {separator}
      <RoomPlan.Properties.Label />
    </div>
  )
}
